import type { Airflow } from '@aviatakz/platform-types';

import { sendEvent } from './lib';

/**
 * flights_payment_page_opened - Открытие страницы оплаты
 */
export const paymentPageOpened = (params: { sourceScreen: string | null }) => {
  sendEvent('flights_payment_page_opened', {
    source_screen: params.sourceScreen,
  });
};

/**
 * flights_pay_button_clicked - Пользователь кликнул по кнопке "Оплатить"
 */
export const payButtonClicked = (params: {
  orderId: string;
  order: Airflow.Order.Entity;
  bill: Airflow.Bill.Entity;
  promocodeModifier?: Airflow.Order.PriceModifier | null;
}) => {
  const isPromocodeUsed = Boolean(params.promocodeModifier);
  const promocodeNumber = params.promocodeModifier
    ? params.promocodeModifier.value
    : null;

  sendEvent('flights_pay_button_clicked', {
    order_id: params.orderId,
    is_promocode_used: isPromocodeUsed,
    promocode_number: promocodeNumber,
    amount: params.order.total,
    bill_id: params.bill.id,
    bill_type: params.bill.type,
    order_number: params.order.number,
  });
};
